<template>
  <div class="sj-procedure">
    <slot v-bind="{ step, status }"></slot>
  </div>
</template>

<script>
/**
 * Procedure组件
 * 封装来自上层的数据给slot
 */
export default {
  name: "SjProcedure",
  props: {
    index: {
      type: [Number, null],
      default: null
    }
  },
  data() {
    return {
      indexLocal: null
    };
  },
  computed: {
    step() {
      return this.$parent.value;
    },
    status() {
      if (!this.$parent.statusList || this.indexLocal === null) return {};
      return this.$parent.statusList[this.indexLocal] || {};
    }
  },
  watch: {
    index: {
      immediate: true,
      handler() {
        this.indexLocal = this.$parent.addProcedure(this);
      }
    }
  },
  destroyed() {
    this.$parent.removeProcedure(this);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.sj-procedure {
  padding: 15px;
  flex-shrink: 0;
  overflow: auto;
}
</style>
